import { Button, Modal, Radio } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { FormattedMessage } from 'react-intl'
import React, { useState } from 'react'

export const MonitorExportButton = ({ onExport }) => {
  const [open, setOpen] = useState(false)
  const [exportType, setExportType] = useState('components')

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleDownload = () => {
    if (onExport) {
      onExport(exportType)
    }
    setOpen(false)
  }

  return (
    <>
      <Button
        id="export-usage-monitor-data"
        onClick={handleOpen}
        icon={<DownloadOutlined />}
      >
        <FormattedMessage
          id="usageMonitor.exportButton"
          defaultMessage="Export"
        />
      </Button>
      <Modal
        title={
          <FormattedMessage
            id="usageMonitor.exportModalTitle"
            defaultMessage="Export Data"
          />
        }
        open={open}
        onCancel={handleClose}
        footer={[
          <Button key="download" type="primary" onClick={handleDownload}>
            <FormattedMessage
              id="usageMonitor.downloadButton"
              defaultMessage="Download"
            />
          </Button>,
        ]}
      >
        <Radio.Group
          onChange={(e) => setExportType(e.target.value)}
          value={exportType}
        >
          <Radio value="components">
            <FormattedMessage
              id="usageMonitor.export.components"
              defaultMessage="Viewed Components"
            />
          </Radio>
          <Radio value="subsystems">
            <FormattedMessage
              id="usageMonitor.export.subsystems"
              defaultMessage="Viewed Subsystems"
            />
          </Radio>
        </Radio.Group>
      </Modal>
    </>
  )
}
